import { AreaMasterThemeSizeConfig } from './types';

const large: AreaMasterThemeSizeConfig = {
  areaMaster: {},
};

export default large;
